import { render, staticRenderFns } from "./DvdBluray.vue?vue&type=template&id=88bb7e36"
import script from "./DvdBluray.vue?vue&type=script&setup=true&lang=ts"
export * from "./DvdBluray.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports